import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { CSVLink } from "react-csv";
import { Layout, Modal, Button, Menu, PageHeader, Table, Radio, Input, Icon, Dropdown, Form, Divider, Popover, Spin, message, Tooltip, Typography } from 'antd';

import emitter from '../Evt.js';

const { Content, Sider } = Layout;
const Confirm = Modal.confirm;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const getIconPropsByStatus = (status) => {
    if (status == 1) {
        return { type: 'check-circle', color: '#00FF7F' };
    } else {
        return { type: 'close-circle', color: '#FF0000' };
    }
}

const commonColumns = [
/**
    {
        title: languageMessages['sequence'],
        dataIndex: 'sequence',
        width: 50
    },*/ {
        title: languageMessages['symbol.code'],
        dataIndex: 'stockCode',
        sorter: (a, b) => a.stockCode < b.stockCode ? -1 : a.stockCode > b.stockCode ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }, {
        title: languageMessages['symbol.name'],
        dataIndex: 'stockName',
        sorter: (a, b) => a.stockName < b.stockName ? -1 : a.stockName > b.stockName ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }, {
        title: languageMessages['datetime'],
        dataIndex: 'datetime',
        sorter: (a, b) => a.datetime < b.datetime ? -1 : a.datetime > b.datetime ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }
];

const commonCompactColumns = [
/**
    {
        title: languageMessages['sequence'],
        dataIndex: 'sequence',
        width: 50
    },*/ {
        title: languageMessages['symbol.code'],
        dataIndex: 'stockCode',
        sorter: (a, b) => a.stockCode < b.stockCode ? -1 : a.stockCode > b.stockCode ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }, {
        title: languageMessages['symbol.name'],
        dataIndex: 'stockName',
        sorter: (a, b) => a.stockName < b.stockName ? -1 : a.stockName > b.stockName ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }, {
        title: languageMessages['datetime'],
        dataIndex: 'datetime',
        sorter: (a, b) => a.datetime < b.datetime ? -1 : a.datetime > b.datetime ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }, {
        title: languageMessages['count'],
        dataIndex: 'count',
        sorter: (a, b) => a.count < b.count ? -1 : a.count > b.count ? 1 : 0,
        sortDirections: ['descend', 'ascend'],
    }
]

const commonCsvDataTitle = [languageMessages['symbol.code'], languageMessages['symbol.name'], languageMessages['datetime']];

class MyFilterPage extends Component {
    constructor(props) {
        super(props);

        this.myDate = new Date();

        let fId = '';
        if (history.location.state !== undefined) {
            let tmpFId = history.location.state.fId;
            fId = tmpFId.toString();
        }

        this.user = {};
        this.state = {
            selectedRowKeys: [],

            columns: [],
            dataSource: [],

            compactColumns: [],
            compactDataSource: [],

            compactSymbolCount: [],

            filterItems: [],

            currentSelectKey: fId,

            validateStatus: '',
            validateMessage: '',

            modalVisible: false,
            modalTitle: '',

            stockCount: 0,

            stockName: '',
            action: '',

            filterAlerts: [],

            filterAlertCounts: {},

            saveStock: false,

            csvData: [],
            fileName: '',

            spinLoadding: true,
            stockGroupLoadding: false,

            displayMode: '0',
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendError", this.callSendError);
        emitter.addListener("callFilterRequestResult", this.callFilterRequestResult);
        emitter.addListener('callfilterAlertResult', this.callfilterAlertResult);

        emitter.addListener('callCustomSymbolGroups', this.callCustomSymbolGroups);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendError', this.callSendError);
        emitter.removeListener('callFilterRequestResult', this.callFilterRequestResult);
        emitter.removeListener('callfilterAlertResult', this.callfilterAlertResult);

        emitter.removeListener('callCustomSymbolGroups', this.callCustomSymbolGroups);
    }

    callSendError = (status) => {
        this.setState({ spinLoadding: false, stockGroupLoadding: false });
    }

    callCustomSymbolGroups = (symbolGroup) => {
        if (symbolGroup.Status === 0) {
            var customStockGroupsCache = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
            if (customStockGroupsCache.length > 0) {
                const index = customStockGroupsCache.findIndex(item => item.groupId === symbolGroup.gi);
                if (index > -1) {
                    customStockGroupsCache[index].groupName = symbolGroup.gn;
                    customStockGroupsCache[index].symbolList = symbolGroup.sg;
                } else {
                    customStockGroupsCache.push({ groupId: symbolGroup.gi, userId: symbolGroup.ui, groupName: symbolGroup.gn, symbolList: symbolGroup.sg });
                }
            } else {
                customStockGroupsCache.push({ groupId: symbolGroup.gi, userId: symbolGroup.ui, groupName: symbolGroup.gn, symbolList: symbolGroup.sg });
            }
            sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(customStockGroupsCache));

            var content = <span>{strReplace(languageMessages['already.add.success'], { '{num}': this.state.stockCount })}，<a href="javascript:;" onClick={this.jumpMyCustomStock}>{languageMessages['view.my.self-selected.stock']}</a></span>;
            this.timerModal(languageMessages['self-selected.stock.added.success'], content);
        } else {
            message.error(symbolGroup.Description);
        }

        this.setState({ stockGroupLoadding: false });
    }

    callFilterRequestResult = (filterResult, filter) => {
        let { filterItems, currentSelectKey } = this.state;

        if (filterResult.Status === 0) {
            if (filter.Action === 'delete') {
                var filtersCache = JSON.parse(sessionStorage.getItem("FiltersCache") || '{}') || {};
                if (filtersCache.hasOwnProperty(filterResult.FilterId)) {
                    delete (filtersCache[filterResult.FilterId]);
                    sessionStorage.setItem("FiltersCache", JSON.stringify(filtersCache));
                }

                const index = filterItems.findIndex(item => item.FilterId === filterResult.FilterId);
                // 如果找到该索引，删除该元素  
                if (index > -1) {
                    filterItems.splice(index, 1);
                }

                if (currentSelectKey === filterResult.FilterId) {
                    var filterItem = filterItems.filter(function (e) { return e.filterId === currentSelectKey });
                    if (filterItem.length > 0) {
                        currentSelectKey = filterItem[0].filterId.toString();
                    }
                }

                message.success(languageMessages['delete.filter.success']);
            } else if (filter.Category === 'enable') {
                // 更新状态
                filterItems = filterItems.map(item => {
                    if (item.filterId === filter.FilterId) {
                        return { ...item, state: filter.State };
                    }
                    return item;
                });
            }
        } else {
            message.error(filterResult.Description);
        }

        this.setState({
            spinLoadding: false,
            filterItems,
            currentSelectKey
        });
    }

    callfilterAlertResult = (filterAlert) => {
        let { currentSelectKey, filterAlerts, columns, dataSource, compactColumns, compactDataSource, compactSymbolCount, csvData } = this.state;

        var filterAlertCounts = JSON.parse(sessionStorage.getItem("FilterAlertCountsCache") || '{}') || {};

        let fId = filterAlert.fi.toString();
        if (currentSelectKey === fId) {
            var sequence = dataSource.length;
            var row = {
                key: sequence,
                sequence: sequence + 1,
                stockCode: filterAlert.sc,
                stockName: filterAlert.sn,
                datetime: filterAlert.dt
            };

            var row1 = {
                key: sequence,
                sequence: sequence + 1,
                stockCode: filterAlert.sc,
                stockName: filterAlert.sn,
                datetime: filterAlert.dt,
                count: 0,
            };

            var tmpColumns = columns.filter(v1 => { return commonColumns.every(v2 => v2.dataIndex !== v1.dataIndex) });

            var csvDataTitle = csvData.shift();
            /**
            var tmpCsvDataTitle = csvDataTitle.filter(function (item) { return item => !commonCsvDataTitle.includes(item) });
            */
            var csvDataItems = [];
            csvDataItems.push(filterAlert.sc);
            csvDataItems.push(filterAlert.sn);
            csvDataItems.push(filterAlert.dt);

            var alerts = filterAlert.a;
            if (alerts !== undefined) {
                Object.keys(alerts).map((key, index) => {
                    const n = tmpColumns.findIndex(item => item.dataIndex === key);
                    if (n === -1) {
                        tmpColumns.push({ title: key, dataIndex: key });
                    }

                    row[key] = parseFloat(alerts[key]).toFixed(4);
                    row1[key] = parseFloat(alerts[key]).toFixed(4);

                    const nnn = csvDataTitle.findIndex(item => item == key);
                    if (nnn === -1) {
                        csvDataTitle.push(key);
                    }

                    csvDataItems.push(parseFloat(alerts[key]).toFixed(4));
                });
            }

            dataSource.unshift(row);

            if (compactSymbolCount.hasOwnProperty(filterAlert.sc)) {
                compactSymbolCount[filterAlert.sc] += 1;

                const ins = compactDataSource.findIndex(item => item.stockCode === filterAlert.sc);
                if (ins > -1) compactDataSource.splice(ins, 1);
            } else {
                compactSymbolCount[filterAlert.sc] = 1;
            }

            row1.count = compactSymbolCount[filterAlert.sc];
            compactDataSource.unshift(row1);

            //tmpCsvDataTitle.sort();
            //csvDataTitle = commonCsvDataTitle.concat(tmpCsvDataTitle.filter(function (item) { return !(commonCsvDataTitle.indexOf(item)) > -1 }));
            csvData.unshift(csvDataTitle);

            csvData.push(csvDataItems);

            tmpColumns.sort((a, b) => a.dataIndex.localeCompare(b.dataIndex));
            columns = commonColumns.concat(tmpColumns.filter(function (item) { return !(commonColumns.indexOf(item)) > -1 }));

            compactColumns = commonCompactColumns.concat(tmpColumns.filter(function (item) { return !(commonCompactColumns.indexOf(item)) > -1 }));

            filterAlerts.push(filterAlert);

            if (filterAlertCounts.hasOwnProperty(filterAlert.fi)) {
                filterAlertCounts[filterAlert.fi] = 0;
            }
            sessionStorage.setItem("FilterAlertCountsCache", JSON.stringify(filterAlertCounts));

            this.setState({ filterAlerts, columns, dataSource, compactColumns, compactDataSource, compactSymbolCount, filterAlertCounts, csvData });
        } else {
            this.setState({ filterAlertCounts });
        }
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        /**
        var filtersCache = JSON.parse(sessionStorage.getItem("FiltersCache") || '{}') || {};
        if (filtersCache !== null && Object.keys(filtersCache).length > 0) {
            this.setFilters(filtersCache);
        } else {
            this.props.dispatch({ type: "action_get_filter_items", payload: { u: this.user.username } });
        }
        */
        this.props.dispatch({ type: "action_get_filter_items", payload: { u: this.user.username } });
    }

    setFilters(filterItems) {
        var { currentSelectKey } = this.state

        var filterAlertCounts = {};

        var fileName = '';
        var csvData = [];
        var csvDataTitle = [];

        var columns = [];
        var dataSource = [];

        var compactSymbolCount = {};

        var compactColumns = [];
        var compactDataSource = [];

        if (filterItems !== undefined && filterItems !== null) {
            if (filterItems.length > 0) {
                var filterName = '';
                if (currentSelectKey === '') {
                    currentSelectKey = filterItems[0].filterId.toString();
                    filterName = filterItems[0].filterName;
                } else {
                    var filterItem = filterItems.filter(function (e) { return e.filterId === currentSelectKey });
                    if (filterItem.length > 0) {
                        filterName = filterItem[0].filterName;
                    }
                }

                fileName = filterName + '_result_' + this.myDate.getYear() + '' + this.myDate.getMonth() + '' + this.myDate.getDate() + '' + this.myDate.getHours() + '' + this.myDate.getMinutes() + '' + this.myDate.getSeconds() + ".csv";

                filterAlertCounts = JSON.parse(sessionStorage.getItem("FilterAlertCountsCache") || '{}') || {};
                if (filterAlertCounts.hasOwnProperty(currentSelectKey)) {
                    filterAlertCounts[currentSelectKey] = 0;
                }
                sessionStorage.setItem("FilterAlertCountsCache", JSON.stringify(filterAlertCounts));

                let filterAlertsCache = JSON.parse(sessionStorage.getItem("FilterAlertsCache") || '{}') || {};
                if (filterAlertsCache.hasOwnProperty(currentSelectKey)) {
                    var filterAlerts = filterAlertsCache[currentSelectKey];
                    var sequence = filterAlerts.length;
                    for (var i in filterAlerts) {
                        var row = {
                            key: sequence - 1,
                            sequence: sequence,
                            stockCode: filterAlerts[i].sc,
                            stockName: filterAlerts[i].sn,
                            datetime: filterAlerts[i].dt
                        }

                        var row1 = {
                            key: sequence - 1,
                            sequence: sequence,
                            stockCode: filterAlerts[i].sc,
                            stockName: filterAlerts[i].sn,
                            datetime: filterAlerts[i].dt,
                            count: 0
                        }

                        var csvDataItems = [];
                        csvDataItems.push(filterAlerts[i].sc);
                        csvDataItems.push(filterAlerts[i].sn);
                        csvDataItems.push(filterAlerts[i].dt);

                        var alerts = filterAlerts[i].a;
                        if (alerts !== undefined) {
                            Object.keys(alerts).map((key, index) => {
                                const n = columns.findIndex(item => item.dataIndex === key);
                                if (n === -1) {
                                    columns.push({ title: key, dataIndex: key });
                                }

                                const nn = compactColumns.findIndex(item => item.dataIndex === key);
                                if (nn === -1) {
                                    compactColumns.push({ title: key, dataIndex: key });
                                }

                                row[key] = parseFloat(alerts[key]).toFixed(4);
                                row1[key] = parseFloat(alerts[key]).toFixed(4);

                                const nnn = csvDataTitle.findIndex(item => item == key);
                                if (nnn === -1) {
                                    csvDataTitle.push(key);
                                }

                                csvDataItems.push(parseFloat(alerts[key]).toFixed(4));
                            });
                        }

                        dataSource.push(row);

                        if (compactSymbolCount.hasOwnProperty(filterAlerts[i].sc)) {
                            compactSymbolCount[filterAlerts[i].sc] += 1;

                            compactDataSource.forEach(item => {
                                if (item.stockCode === filterAlerts[i].sc) item.count = compactSymbolCount[filterAlerts[i].sc];
                            });

                        } else {
                            compactSymbolCount[filterAlerts[i].sc] = 1;

                            row1.count = compactSymbolCount[filterAlerts[i].sc];

                            compactDataSource.push(row1);
                        }

                        csvData.push(csvDataItems);

                        sequence--;
                    }
                }
            }
        }

        csvDataTitle.unshift(languageMessages['datetime']);
        csvDataTitle.unshift(languageMessages['symbol.name']);
        csvDataTitle.unshift(languageMessages['symbol.code']);

        csvData.unshift(csvDataTitle);

        columns.sort((a, b) => a.dataIndex.localeCompare(b.dataIndex));
        columns = commonColumns.concat(columns.filter(function (item) { return !(commonColumns.indexOf(item)) > -1 }));

        compactColumns.sort((a, b) => a.dataIndex.localeCompare(b.dataIndex));
        compactColumns = commonCompactColumns.concat(compactColumns.filter(function (item) { return !(commonColumns.indexOf(item)) > -1 }));

        this.setState({
            filterItems,
            currentSelectKey,

            filterAlertCounts,

            columns,
            dataSource,

            compactColumns,
            compactDataSource,

            compactSymbolCount,

            fileName,
            csvData,

            selectedRowKeys: [],
            spinLoadding: false,
        });
    }

    componentWillReceiveProps(props) {
        var { status, state, filters } = props;

        switch (status) {
            case 'get_filter_items_success':
                this.setFilters(filters);
                break;
            case 'get_filter_items_fail':
                var error = languageMessages['get.data.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['user.exception'];
                        break;
                    default:
                        break;
                }
                message.error(error);
                this.setState({ spinLoadding: false });
                break;
            default:
                break;
        }
    }

    timerModal(title, content) {
        let secondsToGo = 5;
        const modal = Modal.success({
            title: title,
            content: content,
        });

        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
    }

    onNewFilter = e => {
        e.preventDefault();

        Modal.destroyAll();

        sessionStorage.removeItem("VernacularStrategyCache");
        emitter.emit('callJump', 'scan');
        history.push("/scan");

        //emitter.emit('callJump', 'newFilter');
        //history.push("/f");
    };

    jumpMyCustomStock = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'customSymbolGroups');
        history.push("/customStock");
    }

    handleMenuClick = e => {
        var { filterItems } = this.state;

        var currentSelectKey = e.key;

        var compactSymbolCount = {};

        var filterAlertCounts = JSON.parse(sessionStorage.getItem("FilterAlertCountsCache") || '{}') || {};

        var filterName = '';
        var filterItem = filterItems.filter(function (e) { return e.filterId === currentSelectKey });
        if (filterItem.length > 0) {
            filterName = filterItem[0].filterName;
        }

        var fileName = filterName + '_result_' + this.myDate.getYear() + '' + this.myDate.getMonth() + '' + this.myDate.getDate() + '' + this.myDate.getHours() + '' + this.myDate.getMinutes() + '' + this.myDate.getSeconds() + ".csv";
        var csvData = [];
        var csvDataTitle = [];

        var columns = [];
        var dataSource = [];

        var compactColumns = [];
        var compactDataSource = [];

        let filterAlertsCache = JSON.parse(sessionStorage.getItem("FilterAlertsCache") || '{}') || {};
        if (filterAlertsCache.hasOwnProperty(currentSelectKey)) {
            var filterAlerts = filterAlertsCache[currentSelectKey];

            if (filterAlertCounts.hasOwnProperty(currentSelectKey)) {
                filterAlertCounts[currentSelectKey] = 0;
            }
            sessionStorage.setItem("FilterAlertCountsCache", JSON.stringify(filterAlertCounts));

            var sequence = filterAlerts.length;
            for (var i in filterAlerts) {
                var row = {
                    key: sequence - 1,
                    sequence: sequence,
                    stockCode: filterAlerts[i].sc,
                    stockName: filterAlerts[i].sn,
                    datetime: filterAlerts[i].dt
                }

                var row1 = {
                    key: sequence - 1,
                    sequence: sequence,
                    stockCode: filterAlerts[i].sc,
                    stockName: filterAlerts[i].sn,
                    datetime: filterAlerts[i].dt,
                    count: 0
                }

                var csvDataItems = [];
                csvDataItems.push(filterAlerts[i].sc);
                csvDataItems.push(filterAlerts[i].sn);
                csvDataItems.push(filterAlerts[i].dt);

                var alerts = filterAlerts[i].a;
                if (alerts !== undefined) {
                    Object.keys(alerts).map((key, index) => {
                        const n = columns.findIndex(item => item.dataIndex === key);
                        if (n === -1) {
                            columns.push({ title: key, dataIndex: key });
                        }

                        const nn = compactColumns.findIndex(item => item.dataIndex === key);
                        if (nn === -1) {
                            compactColumns.push({ title: key, dataIndex: key });
                        }

                        row[key] = parseFloat(alerts[key]).toFixed(4);
                        row1[key] = parseFloat(alerts[key]).toFixed(4);

                        const nnn = csvDataTitle.findIndex(item => item == key);
                        if (nnn === -1) {
                            csvDataTitle.push(key);
                        }

                        csvDataItems.push(parseFloat(alerts[key]).toFixed(4));
                    });
                }

                dataSource.push(row);

                if (compactSymbolCount.hasOwnProperty(filterAlerts[i].sc)) {
                    compactSymbolCount[filterAlerts[i].sc] += 1;

                    compactDataSource.forEach(item => {
                        if (item.stockCode === filterAlerts[i].sc) item.count = compactSymbolCount[filterAlerts[i].sc];
                    });

                } else {
                    compactSymbolCount[filterAlerts[i].sc] = 1;

                    row1.count = compactSymbolCount[filterAlerts[i].sc];

                    compactDataSource.push(row1);
                }

                csvData.push(csvDataItems);

                sequence--;
            }
        }

        csvDataTitle.unshift(languageMessages['datetime']);
        csvDataTitle.unshift(languageMessages['symbol.name']);
        csvDataTitle.unshift(languageMessages['symbol.code']);

        csvData.unshift(csvDataTitle);

        columns.sort((a, b) => a.dataIndex.localeCompare(b.dataIndex));
        columns = commonColumns.concat(columns.filter(function (item) { return !(commonColumns.indexOf(item)) > -1 }));

        compactColumns.sort((a, b) => a.dataIndex.localeCompare(b.dataIndex));
        compactColumns = commonCompactColumns.concat(compactColumns.filter(function (item) { return !(commonColumns.indexOf(item)) > -1 }));

        this.setState({
            currentSelectKey,

            filterAlertCounts,

            columns,
            dataSource,

            compactColumns,
            compactDataSource,

            compactSymbolCount,

            fileName,
            csvData
        });
    };

    changeDisplayMode = e => {
        this.setState({ displayMode: e.target.value });
    }

    handlePopoverMenuClick = (key, filterId) => {
        switch (key) {
            case 'enable':
                this.isRunFilter(filterId);
                break;
            case 'update':
                this.updateFilter(filterId);
                break;
            case 'remove':
                this.removeFilter(filterId);
                break;
        }
    }

    isRunFilter(fId) {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            this.setState({ spinLoadding: true }, () => {
                var state = 0;
                var filterItem = this.state.filterItems.filter(function (e) { return e.filterId === fId });
                if (filterItem.length > 0) {
                    state = filterItem[0].state === 1 ? 0 : 1;
                }

                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendFilter', userId: this.user.username,
                        msg: {
                            Category: 'enable',
                            Action: 'update',
                            UserId: this.user.username,
                            FilterId: fId,
                            State: state
                        }
                    }
                });
            });
        }
    }

    updateFilter(fId) {
        var ideaId = 0;
        var filterItem = this.state.filterItems.filter(function (e) { return e.filterId === fId });
        if (filterItem.length > 0) {
            ideaId = filterItem[0].ideaId;
        }

        sessionStorage.removeItem("VernacularStrategyCache");
        emitter.emit('callJump', 'scan');
        history.push({ pathname: '/scan', state: { ideaId: ideaId } });
    }

    removeFilter(fId) {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            var ideaName = '';
            var filterItem = this.state.filterItems.filter(function (e) { return e.filterId === fId });
            if (filterItem.length > 0) {
                ideaName = filterItem[0].ideaName;
            }

            var _this = this;
            Confirm({
                title: <div>{languageMessages['make.sure.delete.filter']}“{ideaName}”?</div>,
                content: '',
                okText: languageMessages['yes'],
                okType: 'danger',
                cancelText: languageMessages['no'],
                onOk() {
                    _this.setState({ spinLoadding: true }, () => {
                        _this.props.dispatch({
                            type: "action_send_hub_message", payload: {
                                service: 'SendFilter', userId: _this.user.username,
                                msg: {
                                    Category: 'filter',
                                    Action: 'delete',
                                    ConceptId: 0,
                                    UserId: _this.user.username,
                                    FilterId: fId,

                                    //FilterName: filterName,
                                    //GroupType: stockPoolKey,
                                    //FilterString: filterString,
                                    //SymbolGroupId: stockGroups,
                                    //AlertInterval: alertInterval,
                                    //SourceFilterId: sourceFilterId,
                                    //ValidPeriodBarCount: validPeriodBarCount,
                                    //ValidPeriodBarInterval: validPeriodBarInterval,
                                }
                            }
                        });
                    });
                },
                onCancel() { },
            });
        }
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys, saveStock: selectedRowKeys.length > 0 ? true : false });
    };

    onJoinCustomStock = e => {
        let { filterAlerts, selectedRowKeys } = this.state;

        if (selectedRowKeys.length > 0) {
            var stockCount = selectedRowKeys.length;
            var groupId = e.key;

            var customStockGroups = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
            var tmpCustomGroups = customStockGroups.filter(function (e) { return e.groupId == groupId });
            if (tmpCustomGroups.length > 0) {
                var symbolList = tmpCustomGroups[0].symbolList;
                for (var kk in selectedRowKeys) {
                    var filterAlert = filterAlerts[selectedRowKeys[kk]];
                    if (filterAlert !== undefined) {
                        if (symbolList.indexOf(filterAlert.sc) === -1) {
                            if (symbolList !== '') symbolList += ',';
                            symbolList += filterAlert.sc;
                        }
                    }
                }

                if (symbolList !== '') {
                    this.setState({ stockCount, stockGroupLoadding: false }, () => {
                        this.props.dispatch({
                            type: "action_send_hub_message", payload: {
                                service: 'SendCustomSymbolGroups', userId: this.user.username,
                                msg: {
                                    Action: 'update',
                                    GroupId: groupId,
                                    UserId: this.user.username,
                                    GroupName: tmpCustomGroups[0].groupName,
                                    OldGroupName: tmpCustomGroups[0].groupName,
                                    SymbolList: symbolList
                                }
                            }
                        });
                    });
                }
            } else {
                var symbolList = '';
                for (var kk in selectedRowKeys) {
                    var filterAlert = filterAlerts[selectedRowKeys[kk]];
                    if (filterAlert !== undefined) {
                        if (symbolList.indexOf(filterAlert.sc) === -1) {
                            if (symbolList !== '') symbolList += ',';
                            symbolList += filterAlert.sc;
                        }
                    }
                }

                if (symbolList !== '') {
                    this.setState({
                        modalVisible: true,
                        stockName: '',
                        stockCount,

                        validateStatus: '',
                        validateMessage: '',
                    });
                }
            }
        }
    }

    handleSaveGroupName = () => {
        let { filterAlerts, stockName, selectedRowKeys } = this.state;

        var customStockGroups = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
        var tmpData = customStockGroups.filter(function (e) { return e.groupName == stockName; });
        if (tmpData.length > 0) {
            this.setState({
                validateStatus: 'error',
                validateMessage: languageMessages['stock.pool.name.already.exists'],
            });
        } else {
            if (selectedRowKeys.length > 0) {
                var stockCount = selectedRowKeys.length;
                var symbolList = '';
                for (var kk in selectedRowKeys) {

                    var filterAlert = filterAlerts[selectedRowKeys[kk]];
                    if (filterAlert !== undefined) {
                        if (symbolList.indexOf(filterAlert.sc) === -1) {
                            if (symbolList !== '') symbolList += ',';
                            symbolList += filterAlert.sc;
                        }
                    }
                }

                if (symbolList !== '') {
                    this.setState({ stockCount, stockGroupLoadding: false }, () => {
                        this.props.dispatch({
                            type: "action_send_hub_message", payload: {
                                service: 'SendCustomSymbolGroups', userId: this.user.username,
                                msg: {
                                    Action: 'new',
                                    GroupId: 0,
                                    UserId: this.user.username,
                                    GroupName: stockName,
                                    OldGroupName: stockName,
                                    SymbolList: symbolList
                                }
                            }
                        });
                    });
                }
            }
        }
    };

    handleCancelGroupName = e => {
        this.setState({
            modalVisible: false,
            stockName: '',

            validateStatus: '',
            validateMessage: '',
        });
    };

    onChangeGroupName = e => {
        e.preventDefault();

        let stockName = e.target.value;
        if (stockName !== '') {
            stockName = stockName.slice(0, 20);

            var validateStatus = '';
            var validateMessage = '';
            //var pattern = /^[A-Za-z0-9_\u4e00-\u9fa5]+$/gi;
            var pattern = /^[A-Za-z0-9_]+$/gi;
            if (!pattern.test(stockName)) {
                validateStatus = 'error';
                validateMessage = languageMessages['stock.pool.name.format'];
            }

            this.setState({
                validateStatus: validateStatus,
                validateMessage: validateMessage,
                stockName: stockName
            });
        }
    }

    // 浮动层
    renderPopoverContent = (filterId) => (
        <Menu className="custom-menu">
            <Menu.Item key="enable" onClick={() => this.handlePopoverMenuClick('enable', filterId)}>
                <span>{'Enable Steaming Signal'}</span>
            </Menu.Item>
            <Menu.Item key="update" onClick={() => this.handlePopoverMenuClick('update', filterId)}>
                <span>{languageMessages['update']}</span>
            </Menu.Item>
            <Menu.Item key="remove" onClick={() => this.handlePopoverMenuClick('remove', filterId)}>
                <span>{languageMessages['remove']}</span>
            </Menu.Item>
        </Menu>
    );

    renderFilterItems() {
        let { filterItems, filterAlertCounts } = this.state;

        var filterItemsData = [];
        if (filterItems !== undefined && filterItems !== null) {
            filterItems.map((filterItem, index) => {
                const filterId = filterItem.filterId;
                const filterItemTitle = filterItem.ideaName;
                const alertCount = filterAlertCounts[filterId] || 0;
                const { type, color } = getIconPropsByStatus(filterItem.state); // 根据状态获取图标类型和颜色

                filterItemsData.push(
                    <Menu.Item key={filterId}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <Icon type={type} style={{ color, fontSize: '18px', textShadow: '0 0 3px rgba(0, 0, 0, 0.5)' }} />
                                <Tooltip title={filterItemTitle}>
                                    <Typography.Text ellipsis style={{ color: '#fff', maxWidth: 140, lineHeight: '20px' }}>
                                        {filterItemTitle}
                                    </Typography.Text>
                                </Tooltip>
                                {alertCount > 0 && <span style={{ marginLeft: '5px', color: '#fff' }}>({alertCount})</span>}
                            </div>
                            <Dropdown overlay={this.renderPopoverContent(filterId)} trigger={['click']}>
                                <Tooltip title={'Options'}>
                                    <span onClick={e => e.stopPropagation()} className='large-icon'>
                                        <Icon type="ellipsis" />
                                    </span>
                                </Tooltip>
                            </Dropdown>
                        </div>
                    </Menu.Item>
                );
            });
        }

        if (filterItemsData.length > 0) {
            return <Menu inlineIndent={50} selectedKeys={[this.state.currentSelectKey || '0']} mode="inline" onClick={this.handleMenuClick}>
                {filterItemsData}
            </Menu>;
        } else {
            return <div style={{ textAlign: 'center', padding: '20px 0', color: 'rgba(255, 255, 255, 0.75' }}></div>
        }
    }

    render() {
        var { displayMode, columns, dataSource, compactColumns, compactDataSource, selectedRowKeys } = this.state;

        var customStockGroups = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
        var customStockGroupData = [];
        if (customStockGroups.length > 0) {
            for (let key in customStockGroups) {
                customStockGroupData.push(<Menu.Item key={customStockGroups[key].groupId}>{customStockGroups[key].groupName}</Menu.Item>);
            }
        } else {
            customStockGroupData.push(<Menu.Item key='0'><Icon type="plus-circle" />{languageMessages['new.stock.pool']}</Menu.Item>);
        }

        let menu = (
            <Menu onClick={this.onJoinCustomStock}>
                {customStockGroupData}
            </Menu>
        );

        const rowSelection = {
            title: languageMessages['select.all'],
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectChange
        }

        var formItemLayout = { labelCol: { xs: { span: 24 }, sm: { span: 4 }, }, wrapperCol: { xs: { span: 24 }, sm: { span: 20 }, }, };

        var columnsLength = displayMode === '0' ? compactColumns.length * 150 : columns.length * 150;
        var tableScroll = { x: columnsLength };

        return (<Content className='main-container'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Modal title={languageMessages['new.stock.pool']}
                visible={this.state.modalVisible}
                maskClosable={false}
                onOk={this.handleSaveGroupName}
                confirmLoading={this.state.stockGroupLoadding}
                onCancel={this.handleCancelGroupName}>
                <Form {...formItemLayout}>
                    <Form.Item
                        label={languageMessages['stock.pool.name.form']}
                        hasFeedback
                        validateStatus={this.state.validateStatus}
                        help={this.state.validateMessage}>
                        <Input placeholder={languageMessages['stock.pool.name.placeholder']} id={this.state.validateStatus} value={this.state.stockName} onChange={this.onChangeGroupName} />
                    </Form.Item>
                </Form>
            </Modal>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['my filter']}</h1>)}
                        extra={[
                            <Button key="1" size='small' onClick={this.onNewFilter}>{languageMessages['new filter']}</Button>
                        ]} />
                </div>
                <Layout className='main-content'>
                    <Sider width={300}>
                        <PageHeader className='common-sider-header' title={languageMessages['my filter']} />
                        <Divider />
                        <div className="common-sider-content">
                            {this.renderFilterItems()}
                        </div>
                    </Sider>
                    <Layout className='common-content'>
                        <div>
                            <div className='common-left-toolbar'>
                                <Radio.Group value={displayMode} onChange={this.changeDisplayMode} buttonStyle="solid">
                                    <Radio.Button value="0">{languageMessages['compact']}</Radio.Button>
                                    <Radio.Button value="1">{languageMessages['detailed']}</Radio.Button>
                                </Radio.Group>
                            </div>
                            <div className='common-toolbar'>
                                <Dropdown key="1" overlay={menu} disabled={!this.state.saveStock}><Button size='small'>{languageMessages['add.choice']}<Icon type="down" /></Button></Dropdown>
                                <CSVLink key="2" data={this.state.csvData} filename={this.state.fileName} className="ant-btn ant-btn-sm" style={{ marginLeft: '10px' }} target="_blank">
                                    <Icon type="download" /><span>{languageMessages['downloads.alerts']}</span>
                                </CSVLink>
                            </div>
                        </div>
                        <Table rowSelection={rowSelection} locale={{ emptyText: ' ' }}
                            bordered size='small' scroll={tableScroll}
                            columns={displayMode === '0' ? compactColumns : columns}
                            dataSource={displayMode === '0' ? compactDataSource : dataSource}
                            pagination={{ pageSize: 30 }} />
                    </Layout>
                </Layout>
            </Spin>
        </Content>)
    }
}

function mapStateToProps(state) {
    return state.filter;
}

const page = connect(mapStateToProps)(MyFilterPage);
export { page as default }